import { render, staticRenderFns } from "./saveDataMy.vue?vue&type=template&id=3456da86&scoped=true&"
import script from "./saveDataMy.vue?vue&type=script&lang=js&"
export * from "./saveDataMy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3456da86",
  null
  
)

export default component.exports